import React from "react";
import Navbar from "../../assets/Navbar/Navbar";
import Footer from "../../assets/Footer/Footer";
// import '../Work.css';

// import "../Learning Outcome/LO.css"; // Import the CSS file

import { useNavigate } from "react-router-dom";
// import gif1 from "../../assets/Images/bag.GIF";
import figma from "../../assets/Images/figma.png";
import lowprot1 from "../../assets/Images/lowfidprot.JPG";
import lowprot2 from "../../assets/Images/lowfidprot1.JPG";
import Slideshow from "../../assets/Slideshow/Slideshow"; 

import BreadcrumbHeader from "../../assets/Breadcrumbs/Breadcrumbs";





const Lo1User = () => {
    const navigate = useNavigate();
    const images = [figma, lowprot1, lowprot2];

    

    return (
        <div className="page-container">
            <Navbar />
            <div className="content-lo1-headings">
                <h1>User Stories</h1>
                <p></p>

                
            </div>

            <div className="line"></div>
            <div style={{ padding: '0.1rem 7.5rem' }}>
                                                                <BreadcrumbHeader />
                        </div>
            <div className="content-lo1">
                <div className="content-lo1-user">
                    <div className="content-lo1-user-text">
                        <h2>We come up with the User Stories</h2>
                        <p>
                            My group and I discussed the user stories before making our interactive products. This step was crucial in making sure that we designed and developed actually met the needs and expectations of our target audience student who
                            might be interested in joining the Virtual Production minor. User stories help us define our goals and problems we are trying to solve with our concept, I understand the value of having a user stories since, I could
                            be able to make a more focused design and align it with our campaign.
                            
                        </p>
                        <h2>This is our User stories</h2>
                        <ul className="list-user">
                            <li>1. As a student, I want to learn about the minor so that I know if I want to sign up for it.</li>
                            <li>2. As a student, I want to know if a minor is relevant to my studies.</li>
                            <li>3. As a student, I want to know what future opportunities the minor gives me.</li>
                            <li>4. As a student, I want an eye-catching way to learn about the minor.</li>
                            <li>5. As a student, I want to learn about the minor through social media.</li>
                            <li>6. As a student, I want to engage in a fun game on the info monitors, so that I learn about the minor in a fun way</li>
                            <li>7. As a student, I want to engage in an interesting social-media type of content on the info monitors, so that not only am I interested in what the monitors say, but also I learn about the minor.</li>
                            <li>8. As a student, I want to be intrigued by a guerilla marketing poster.</li>
                            <li>9. As a student, I want to look at an interesting poster so that I can learn about the minor in a traditional way.</li>
                            <li>10. As a student, I want to pay attention to the poster. </li>
                            <li>11. As a student, I should be able to find information and research about the minor. </li>

                        </ul>
                        <h2>Translating the User Stories to the product</h2>
                        <ul>
                            <li>For User Stories no 4, to make it more catching I implemented cat meme as a theme campaign to attract students</li>
                            <li>For User Stories no 9, I created a poster where the cat meme theme and the information for the virtual production visible, making sure that the poster stays informative while also having fun element inside</li>
                            <li>For User Stories no 10, Me and my group leader Adib made sure to add 3D model on the poster while also having arduino to create an effect of having a real cat sounds, making our poster interactive and create engagement to our target audience</li>
                            <li>For User Stories no 11, I made sure to add a few information on the poste while also giving a QR code to make it simple for our target audience to come and check more about the minor</li>
                        </ul>
                        <p>
                            This user centered design process helped us ensure that our final product wasn't just creative, but also functional and aligned with our target audience expectations and needs
                        </p>
                    </div>

                    {/* <div className="content-lo4-advisory-slideshow">
                        <Slideshow images={images} />

                    </div> */}

                    
                </div>
            </div>

            <Footer />
            </div>
    );
};

export default Lo1User;